// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"bd6ff65f","130":"95bc1247","399":"4033ae4d","446":"00343f89","483":"9f30afbf"}[chunkId] + ".chunk.css";
};